"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerSchemaProperties = exports.SchedulerSchema = exports.SchedulerStatusEnum = exports.SchedulerReschedulingOptionsSchema = exports.GroupSchedulerSchema = exports.RoundRobinSchema = exports.RoundRobinPriorityEnum = exports.OpenHoursSchema = void 0;
// TODO: Move all this to the shared lib whenever it's available.
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const smart_action_schema_1 = require("./smart-action-schema");
exports.OpenHoursSchema = zod_1.z.object({
    startTime: zod_1.z.string(),
    endTime: zod_1.z.string(),
    weekdays: zod_1.z.object({
        mon: zod_1.z.boolean(),
        tue: zod_1.z.boolean(),
        wed: zod_1.z.boolean(),
        thu: zod_1.z.boolean(),
        fri: zod_1.z.boolean(),
        sat: zod_1.z.boolean(),
        sun: zod_1.z.boolean(),
    }),
});
exports.RoundRobinPriorityEnum = zod_1.z.enum(["availability", "assignee"]);
exports.RoundRobinSchema = zod_1.z.object({
    members: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), availabilityId: zod_1.z.string() })),
    priority: exports.RoundRobinPriorityEnum.optional(),
    memberSwitching: zod_1.z.boolean().optional(),
    ownerChange: zod_1.z.boolean().optional(),
    roster: zod_1.z.boolean().optional(),
});
exports.GroupSchedulerSchema = zod_1.z.object({
    maxParticipants: zod_1.z.number().nullable().optional(),
    type: zod_1.z.enum(["ongoing", "curriculum"]),
});
exports.SchedulerReschedulingOptionsSchema = zod_1.z.object({
    allowedActions: zod_1.z.enum(["none", "cancel", "reschedule", "cancel_reschedule"]),
    minimumNotice: zod_1.z.object({ duration: zod_1.z.number() }),
    reasonRequired: zod_1.z.boolean(),
});
exports.SchedulerStatusEnum = zod_1.z.enum(["active", "inactive", "deleted"]);
exports.SchedulerSchema = base_schema_1.BaseSchema.extend({
    title: zod_1.z.string(),
    status: exports.SchedulerStatusEnum,
    slug: zod_1.z.string().optional(),
    smartActions: smart_action_schema_1.SmartActionTemplateSchema.array().optional(),
    messagingInvite: zod_1.z.boolean().optional(),
    icon: zod_1.z.string(),
    duration: zod_1.z.number().optional().nullable(),
    communication: zod_1.z.array(zod_1.z.object({
        value: zod_1.z.string(),
        memberId: zod_1.z.string().optional(),
        roundRobinMemberIds: zod_1.z.array(zod_1.z.string()).optional(),
        extra: zod_1.z.string().optional(),
    })),
    availabilityId: zod_1.z.string().nullable().optional(),
    description: zod_1.z.string().optional(),
    sharedWith: zod_1.z.array(zod_1.z.string()).optional(),
    bufferTimeAfter: zod_1.z.number().nullable().optional(),
    bufferTimeBefore: zod_1.z.number().nullable().optional(),
    maximumLeadTimeDays: zod_1.z.number().nullable().optional(),
    mimimumLeadTimeDays: zod_1.z.number().nullable().optional(),
    minimumLeadTimeHours: zod_1.z.number().nullable().optional(),
    productId: zod_1.z.string().optional().nullable(),
    publicOrder: zod_1.z.number().nullable().optional(),
    secret: zod_1.z.boolean().optional(),
    startTimeInterval: zod_1.z.string().optional(),
    maximumDayUsage: zod_1.z.number().optional().nullable(),
    maximumWeekUsage: zod_1.z.number().optional().nullable(),
    roundRobin: exports.RoundRobinSchema.optional().nullable(),
    groupScheduler: exports.GroupSchedulerSchema.optional().nullable(),
    reminders: zod_1.z.array(zod_1.z.any()).optional(),
    reschedulingOptions: exports.SchedulerReschedulingOptionsSchema.optional(),
    billingRateId: zod_1.z.string().optional().nullable(),
});
exports.SchedulerSchemaProperties = {
    collectionName: "schedulers",
    deleteMode: schema_properties_interface_1.DeleteMode.InStatus,
};
//# sourceMappingURL=scheduler-schema.js.map